import type { $Fetch } from "ofetch";
import { ClsTomadorNFSe } from "../../classes/TomadorNFSe";

/**
 * Nome do Controller da API
 */
const controller = "/tomador";

/**
 * Classe de gerenciamento de chamadas da API de tomadores
 *
 * @class
 */
export default class TomadorApi {
    /**
     * Instância da dependência da API (ofetch)
     */
    private api;

    /**
     * Cria uma nova instância da classe TomadorApi.
     * @constructor
     * @param api - Instância da dependência da API (ofetch).
     */
    constructor(api: $Fetch) {
        this.api = api;
    }

    /**
     * @returns Lista de Tomadores
     */
    list() {
        return this.api<{
            result: {
                tomadores: {
                cnpj: string;
                codigo: number;
                razaoSocial: string;
                status: string;
                }[]
            }
    }>(`${controller}/listar-tomadores`, {
            method: "GET",
        });
    }

    /**
     * Verifica se o tomador existe pelo CNPJ.
     * @param cnpj - CNPJ do tomador
     * @returns Boolean indicando se o tomador existe
     */
    checkIfTomadorExists(cnpj: string) {
        return this.api<any>(`${controller}/existetomador/${cnpj}`, {
            method: "GET",
        });
    }

    /**
     * Retorna os dados de um tomador.
     * @param codTomador - Código do tomador
     * @returns Dados do tomador
     */
    getTomadorData(codTomador: number) {
        return this.api<any>(`${controller}/dados-tomador/${codTomador}`, {
            method: "GET",
        });
    }

    /**
     * Cadastra um novo tomador.
     * @param tomador - Dados do tomador a ser cadastrado
     * @returns Resultado do cadastro
     */
    createTomador(tomador: ClsTomadorNFSe) {
        return this.api<any>(`${controller}/cadastrar`, {
            method: "POST",
            body: tomador,
        });
    }

    /**
     * Atualiza os dados de um tomador.
     * @param tomador - Dados atualizados do tomador
     * @returns Resultado da atualização
     */
    updateTomador(tomador: ClsTomadorNFSe) {
        return this.api<any>(`${controller}/atualizar`, {
            method: "PUT",
            body: tomador,
        });
    }
}
